import { Component, Host, h, Prop } from '@stencil/core';

@Component({
    tag: 'sew-ws-footer-linklist',
    styleUrl: 'sew-ws-footer-linklist.scss',
    shadow: true,
})
export class SewWsfooterLinklist {
    @Prop() headline: string;

    render() {
        return (
            <Host>
                <div innerHTML={this.headline} class="headline"></div>
                <slot></slot>
            </Host>
        );
    }
}
